import styled from 'styled-components';

export const PageLayoutContainer = styled.div`
  height: calc(100vh - 64px); // all height - header height
  width: 100%;
  padding: 2rem;

  overflow-y: auto;
`;
